<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班组：</span>
        </div>
        <el-select v-model="formData.groupCode" size="small" style="width: 280px">
          <el-option v-for="item in attendanceGroupList" :key="item.groupCode"
                     :label="item.groupName" :value="item.groupCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班次
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">系统默认以第一个班次进行排班</div>
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        </div>

        <div style="flex-direction: column;align-items: flex-start;">
          <div v-for="(item, index) in classesArr" :key="index" style="margin-bottom: 10px;">
            <el-select v-model="item.code" size="small" style="width: 280px">
              <el-option v-for="item in attendanceClassList" :key="item.classesCode" :label="item.classesName" :value="item.classesCode"></el-option>
            </el-select>
            <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeClassesItem(index)" v-if="index > 0"></i>
            <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addClassesItem(index)" v-if="index === classesArr.length - 1"></i>
          </div>
        </div>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/AttendancePoint'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'attendance-scheduling-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '排班管理'
        }],
        mainTitle: '添加排班班组',
        subheading: '',

        attendanceGroupList: [],
        attendanceClassList: [],
        classesArr: [
          {code: ''}
        ],
        classesCodeArr: [],
        formData: {
          groupCode: '',
          classesCodes: ''
        },
      }
    },
    created () {
      this.getAttendanceGroupListForUnboundClasses()
      this.getAttendanceClassList()
    },
    methods: {
      getAttendanceGroupListForUnboundClasses () {
        this.$axios.post(api.getAttendanceGroupListForUnboundClasses, {})
          .then(res => {
            let list = res.data.data
            this.attendanceGroupList = list
          })
          .catch(errorHandler('获取班组列表失败'))
      },

      getAttendanceClassList () {
        this.$axios.post(api.getAttendanceClassList, {})
          .then(res => {
            let list = res.data.data
            this.attendanceClassList = list
          })
          .catch(errorHandler('获取班次列表失败'))
      },

      // 增加班次
      addClassesItem (index) {
        if (!this.classesArr[index].code) {
          nError('请先选择当前班次')
          return false
        }
        let obj = {
          code: '',
        }
        this.classesArr.push(obj)
      },

      // 删减班次
      removeClassesItem (index) {
        this.classesArr.splice(index, 1)
      },

      toManagementPage () {
        this.$router.push({
          name: 'attendance-scheduling-manage'
        })
      },

      // 添加
      confirm () {
        if (!this.formData.groupCode) {
          nError('请选择班组')
          return false
        }
        if (!this.classesArr[0].code) {
          nError('请选择班次')
          return false
        }
        let classesCodes = []
        this.classesArr.map(v => {
          if (v.code) {
            if (classesCodes.indexOf(v.code) === -1) {
              classesCodes.push(v.code)
            }
          }
        })
        this.formData.classesCodes = classesCodes.join(',')
        this.$axios.post(api.addGroupClassesRelation, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('添加失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 190px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 600px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceScheduling/AttendanceSchedulingAdd.vue